import { SET_SUB_NAVBAR } from '../actions/navbar';

const defaultState = {
  subNavbar: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_SUB_NAVBAR:
      return {
        ...state,
        subNavbar: action.subNavbar,
      };
    default:
      return state;
  }
};
